import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class LabForm extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      name: "",
      sex: "",
      age: "",
      myParentTrigger: "",
      tablevaluesglobal: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    $(".yesSelected").click(function () {
      $(".hiddenPart").show();
    });
    $(".noSelected").click(function () {
      $(".hiddenPart").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();

    let PreviousObstetricUltrasound = event.target[0].value;
    let NumPreviousUltrasound = event.target[1].value;
    let finalpayload = {};
    finalpayload.PreviousObstetricUltrasound = PreviousObstetricUltrasound;
    finalpayload.NumPreviousUltrasound = NumPreviousUltrasound;
    finalpayload.ultrasound = this.state.tablevaluesglobal.ultrasound;
    // console.log(finalpayload);

    axios
      .post(
        this.api_url+"triage/obstetricultrasound/main",
        finalpayload,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);

        if (response.status == 200) {
          $("#SubmitSuccess").show();
          $("#SubmitError").hide();
          setTimeout(function () {
            window.location.href = "/preplan/analysis";
          }, 500);
        } else {
          $("#SubmitSuccess").hide();
          $("#SubmitError").show();

          // $(response).each(function (index) {
          //     var individualResult = '<div className="card"> <div className="card-body">' + index.name + '</div> </div>'
          //     $('.resultDisplay').append(individualResult);
          // });
          // $('.resultDisplay').show();
          this.setState({ response: response });
          // console.log(response)resultDisplay
          //
        }
      })
      .catch((error) => {
        $("#SubmitSuccess").hide();
        $("#SubmitError").show();
        console.log(error);
      });
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  formatTableOutput(data) {
    console.log("data");
    console.log(data);
    let topobj = {}; //empty final obj
    let tableobj = {}; //empty obj
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {}; //local scope empty obj
      trimobj.date = data[i][1];
      trimobj.result = data[i][2];
      tableobj["trimester" + [i + 1]] = trimobj; //create dynamic keys i.e trimester1,trimester2
      topobj.ultrasound = tableobj;
    }
    this.state.tablevaluesglobal = topobj;
  }

  getTableValues(event) {
    // console.log('entns');
    // console.log(event);
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [
      ["Widal: Oag__", "", "", "Hag", "", "", "FBS", "", "75 - 120 mg/dl"],
      ["H.PYLORI___________________", "", "", "RBS", "", "75 - 180 mg/dl"],
      ["BRUCELLA__________________", "", "", "HbA1", "", ""],

      // ["4th", "", ""],
    ];
    const columns = [
      "ASO",
      "",
      "",
      "",
      "",
      "",
      "TEST",
      "RESULT",
      "NORMAL RANGE",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    // {""1st":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}

    const { name, sex, age } = this.state;
    return (
      <div>
        <Headers />

        <main className="content-container ">
          <div className="container p-2">
            <form id="obsform" onSubmit={this.handleSubmit}>
              <div className="py-1">
                <h6 className="text-capitalize" style={fontFamilyNunito}>
                  Name
                </h6>
                <input
                  onChange={this.handleChange}
                  value={name}
                  name="name"
                  className="form-control"
                  type="text"
                />
              </div>
              <div className="py-1">
                <h6 className="text-capitalize" style={fontFamilyNunito}>
                  Age
                </h6>
                <input
                  onChange={this.handleChange}
                  value={age}
                  name="age"
                  className="form-control"
                  type="text"
                />
              </div>

              <div className="py-1">
                <h6 className="text-capitalize" style={fontFamilyNunito}>
                  Sex
                </h6>
                <select
                  onChange={this.handleChange}
                  value={sex}
                  name="sex"
                  className="form-control"
                  required
                >
                  <optgroup label="AnteNatal History Previous Obstetric Ultrasound">
                    <option selected disabled></option>
                    <option className="yesSelected" value="yes">
                      Male
                    </option>
                    <option className="yesSelected" value="yes">
                      Female
                    </option>
                  </optgroup>
                </select>
              </div>

              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Lab Form
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
              {/* <div className="alert alert-danger contactAdmin" style={displayHidden} role="alert">
                                <strong>Wait! </strong>Contact Administrator to get account approval.
                            </div> */}
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default LabForm;
